export const WIFI = "Wifi";
export const STANDALONE = "Standalone";
export const SIGFOX = "Sigfox";
